// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Status color scales */
export const statusColors = {
	success: {
		DEFAULT: "var(--color-status-success-default)",
		light: "var(--color-status-success-light)",
		dark: "var(--color-status-success-dark)",
		foreground: "var(--color-status-success-foreground)",
	},
	warning: {
		"50": "var(--color-status-warning-50)",
		"100": "var(--color-status-warning-100)",
		"200": "var(--color-status-warning-200)",
		"300": "var(--color-status-warning-300)",
		"400": "var(--color-status-warning-400)",
		"500": "var(--color-status-warning-500)",
		"600": "var(--color-status-warning-600)",
		"700": "var(--color-status-warning-700)",
		"800": "var(--color-status-warning-800)",
		"900": "var(--color-status-warning-900)",
		DEFAULT: "var(--color-status-warning-default)",
		light: "var(--color-status-warning-light)",
		dark: "var(--color-status-warning-dark)",
		foreground: "var(--color-status-warning-foreground)",
	},
	error: {
		"50": "var(--color-status-error-50)",
		"100": "var(--color-status-error-100)",
		"200": "var(--color-status-error-200)",
		"300": "var(--color-status-error-300)",
		"400": "var(--color-status-error-400)",
		"500": "var(--color-status-error-500)",
		"600": "var(--color-status-error-600)",
		"700": "var(--color-status-error-700)",
		"800": "var(--color-status-error-800)",
		"900": "var(--color-status-error-900)",
		DEFAULT: "var(--color-status-error-default)",
		light: "var(--color-status-error-light)",
		dark: "var(--color-status-error-dark)",
		foreground: "var(--color-status-error-foreground)",
	},
} as const;

/** Gradient tokens */
export const gradientColors = {
	primary: "var(--color-gradients-primary)",
	loading: "var(--color-gradients-loading)",
	tertiaryOverlay: "var(--color-gradients-tertiary-overlay)",
	gridSheer: "var(--color-gradients-grid-sheer)",
	darkCountdown: "var(--color-gradients-dark-countdown)",
	photoScrim: "var(--color-gradients-photo-scrim)",
	photoScrimSoft: "var(--color-gradients-photo-scrim-soft)",
	auctionWash: "var(--color-gradients-auction-wash)",
} as const;

/** Opacity tokens */
export const opacityColors = {
	hero: "var(--color-opacity-hero)",
	primary: "var(--color-opacity-primary)",
	secondary: "var(--color-opacity-secondary)",
	tertiary: "var(--color-opacity-tertiary)",
} as const;

/** Overlay color tokens */
export const overlayColors = {
	dark: "var(--color-overlay-dark)",
	darkSemi: "var(--color-overlay-dark-semi)",
	medium: "var(--color-overlay-medium)",
	darkMedium: "var(--color-overlay-dark-medium)",
	darkStrong: "var(--color-overlay-dark-strong)",
	darkHeavy: "var(--color-overlay-dark-heavy)",
	darkVeryHeavy: "var(--color-overlay-dark-very-heavy)",
	darkVerySubtle: "var(--color-overlay-dark-very-subtle)",
	darkSubtle: "var(--color-overlay-dark-subtle)",
	darkLight: "var(--color-overlay-dark-light)",
	light: "var(--color-overlay-light)",
	lighter: "var(--color-overlay-lighter)",
	nearOpaque: "var(--color-overlay-near-opaque)",
	lightest: "var(--color-overlay-lightest)",
	verySubtle: "var(--color-overlay-very-subtle)",
	subtle: "var(--color-overlay-subtle)",
	mediumWhite: "var(--color-overlay-medium-white)",
	glass: "var(--color-overlay-glass)",
	mediumTranslucent: "var(--color-overlay-medium-translucent)",
	semiTransparent: "var(--color-overlay-semi-transparent)",
	medium60: "var(--color-overlay-medium60)",
	code: "var(--color-overlay-code)",
	warning: "var(--color-overlay-warning)",
	errorLight: "var(--color-overlay-error-light)",
	brandHover: "var(--color-overlay-brand-hover)",
	brandActive: "var(--color-overlay-brand-active)",
	brandFocus: "var(--color-overlay-brand-focus)",
	neutralHover: "var(--color-overlay-neutral-hover)",
	neutralActive: "var(--color-overlay-neutral-active)",
	neutralPressed: "var(--color-overlay-neutral-pressed)",
} as const;
